// extracted by mini-css-extract-plugin
module.exports = {"container":"Kpi_container__2ixFW","caption":"Kpi_caption__2VL8i"};